import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { Reveal } from "./motion";
import { useI18n } from "@/i18n";

const images = [
  "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  "https://images.pexels.com/photos/4481328/pexels-photo-4481328.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1450778869180-41d0601e046e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
];
const numbers = ["01", "02", "03", "04"];

export function Categories() {
  const { t } = useI18n();
  return (
    <section id="catalogo" className="w-full max-w-screen-2xl mx-auto px-4 md:px-8 py-24 md:py-32">
      <div className="grid md:grid-cols-12 gap-8 items-end mb-16">
        <Reveal className="md:col-span-8">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#ff4500] mb-4">{t.categories.kicker}</p>
          <h2 className="font-clash font-black uppercase leading-[0.95] text-[#f5f5f5] text-4xl md:text-6xl tracking-tight">
            {t.categories.headingA} <br /> {t.categories.headingB}
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-4">
          <p className="font-plex text-[#a3a3a3] md:text-right">{t.categories.sub}</p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {t.categories.items.map((c, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <motion.a
              href="#registro"
              data-testid={`category-card-${i}`}
              whileHover="hover"
              className="group relative block bg-[#0a0a0a] h-full p-7 md:p-8 overflow-hidden"
            >
              <div className="relative z-10 flex items-start justify-between mb-6">
                <span className="font-mono text-sm text-[#a3a3a3]">{numbers[i]}</span>
                <span className="font-mono text-[10px] uppercase tracking-wider border border-white/15 text-[#a3a3a3] px-2 py-1">
                  {c.tag}
                </span>
              </div>

              <div className="relative z-10 aspect-[4/3] overflow-hidden mb-6 border border-white/10">
                <motion.img
                  variants={{ hover: { scale: 1.08 } }}
                  transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                  src={images[i]}
                  alt={c.title}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-[filter] duration-500"
                />
                <div className="absolute inset-0 bg-[#ff4500] mix-blend-multiply opacity-0 group-hover:opacity-20 transition-opacity duration-500" />
              </div>

              <h3 className="relative z-10 font-clash font-bold text-2xl text-[#f5f5f5] mb-2">{c.title}</h3>
              <p className="relative z-10 font-plex text-sm text-[#a3a3a3] mb-6">{c.desc}</p>
              <span className="relative z-10 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-wider text-[#ff4500]">
                {t.categories.cta}
                <ArrowUpRight size={16} weight="bold" className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
              </span>

              <div className="absolute inset-x-0 bottom-0 h-0.5 bg-[#ff4500] scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
            </motion.a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
